import { Separator } from "../../../../components/ui/separator";

export const FotterByAnima = (): JSX.Element => {
  // Company information data
  const companyInfo = {
    description:
      "Keeping energetic kids happily busy during travel with screen-free, creative activities.",
    address: "T-Hub, Raidurgam, Knowledge City Rd, Hyderabad, Telangana 500081",
    phone: "+91 8639785747",
    email: "contact@littlemonsters.com",
  };

  // Footer links data
  const footerLinks = [
    {
      title: "Quick Links",
      links: ["Features", "Benefits", "Activites", "Reviews"],
    },
    {
      title: "Socials",
      links: ["LinkedIn", "X", "Instagram", "Facebook"],
    },
    {
      title: "Support",
      links: ["News", "FAQ", "About", "Privacy Policy"],
    },
  ];

  // Bottom links data
  const bottomLinks = ["English", "Privacy", "Legal"];

  return (
    <footer className="flex flex-col items-start gap-12 p-12 w-full bg-[#169C97]">
      <div className="flex items-start justify-between w-full flex-wrap gap-8">
        {/* Company information section */}
        <div className="flex flex-col items-start gap-6 w-full md:w-auto">
          <div className="flex flex-col items-start gap-6 w-full">
            {/* Logo */}
            <div className="w-24 h-12 rounded-xl">
              <img
                src="assets/Logo.png" // Use imported logo here
                alt="Little Monsters Travel Kit Logo" // Descriptive alt text
                className="w-full h-full object-cover rounded-xl"
              />
            </div>

            <p className="font-['Plus_Jakarta_Sans',Helvetica] font-normal text-white text-base leading-6">
              {companyInfo.description}
            </p>
          </div>

          <div className="flex flex-col items-start gap-1 w-full">
            <h4 className="font-['Plus_Jakarta_Sans',Helvetica] font-semibold text-white text-sm leading-[21px]">
              Address:
            </h4>
            <p className="font-['Plus_Jakarta_Sans',Helvetica] font-normal text-white text-sm leading-[21px]">
              {companyInfo.address}
            </p>
          </div>

          <div className="flex flex-col items-start gap-3 w-full">
            <h4 className="font-['Plus_Jakarta_Sans',Helvetica] font-semibold text-white text-sm leading-[21px]">
              Contact:
            </h4>
            <div className="flex flex-col items-start w-full">
              <p className="font-['Plus_Jakarta_Sans',Helvetica] font-normal text-white text-sm leading-[21px]">
                {companyInfo.phone}
              </p>
              <a
                href={`mailto:${companyInfo.email}`}
                className="font-['Plus_Jakarta_Sans',Helvetica] font-normal text-white text-sm leading-[21px] underline"
              >
                {companyInfo.email}
              </a>
            </div>
          </div>
        </div>

        {/* Links section */}
        <div className="flex items-start gap-12 flex-wrap">
          {footerLinks.map((column, index) => (
            <div
              key={index}
              className="flex flex-col w-[120px] items-start gap-6"
            >
              <h3 className="font-['Plus_Jakarta_Sans',Helvetica] font-bold text-white text-xl leading-[30px]">
                {column.title}
              </h3>
              <div className="flex flex-col items-start gap-4 w-full">
                {column.links.map((link, linkIndex) => (
                  <a
                    key={linkIndex}
                    href="#"
                    className="opacity-50 font-['Plus_Jakarta_Sans',Helvetica] font-medium text-white text-base leading-6 hover:opacity-80 transition-opacity"
                  >
                    {link}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Separator className="bg-[#e6e6e6] w-full" />

      <div className="flex items-center justify-between w-full flex-wrap gap-4">
        <p className="font-['DM_Sans-Regular',_Helvetica] font-normal text-white text-base">
          © 2024, LittleMonsters. All rights reserved.
        </p>

        <div className="flex items-center gap-8">
          {bottomLinks.map((link, index) => (
            <a
              key={index}
              href="#"
              className="inline-flex h-4 items-center opacity-50 font-['Plus_Jakarta_Sans',Helvetica] font-medium text-white text-sm leading-[21px] hover:opacity-80 transition-opacity"
            >
              {link}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};
